import configuration from "../config";
import axios from "axios";

const API_URL = configuration.API_URL;
const user = JSON.parse(localStorage.getItem("userData"));
if (user) {
  if (user.hasOwnProperty("token")) {
    var token = user.token;
  } else {
    var token = "";
  }
} else {
  var token = "";
}

axios.defaults.headers.common = {
  Authorization: `app FE1BF69BA30D5251AB3A40400E178ABA5905B151CB88192A49EFBA85E3CB9127`,
};

export function Fetch(type, rootes, jsondata) {
  return new Promise((resolve, reject) => {
    switch (type) {
      case "post":
        axios
          .post(API_URL + `${rootes}`, jsondata)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
        break;
      case "get":
        axios
          .get(API_URL + `${rootes}`, jsondata)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
        break;
      case "delete":
        axios
          .delete(API_URL + `${rootes}`, jsondata)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
        break;
    }
  });
}
export default axios;